import { Injectable } from "@angular/core";
import { differenceInDays } from "date-fns";
@Injectable({ providedIn: "root" })
export class ProductService {
  resetProductExpiry({
    expiresAt,
    expiryUpdatedAt,
  }: {
    expiresAt: string;
    expiryUpdatedAt: string;
  }) {
    const days = differenceInDays(new Date(expiresAt), new Date(expiryUpdatedAt));
    return this.addDays(days);
  }

  addDays(days: number) {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
  }
  getExpiryDisplayText(expiryDate: string | Date): { text: string; isExpired: boolean } {
    const expiry = new Date(expiryDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const isExpired = expiry < today;

    if (isExpired) {
      return { text: "Product is expired!", isExpired: true };
    }

    const diffDays = differenceInDays(expiry, today);
    return {
      text: `Expires in ${diffDays} day${diffDays === 1 ? "" : "s"}`,
      isExpired: false,
    };
  }
}
